import { ReactNode } from "react";

type TooltipProps = {
  id?: string;
  label: string;
  children: ReactNode;
  position?: "top" | "bottom" | "left" | "right";
};

export const Tooltip = ({ id, label, children, position = "top" }: TooltipProps) => {
  const positionClasses = {
    top: "bottom-full left-1/2 transform -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 transform -translate-x-1/2 mt-2",
    left: "right-full top-1/2 transform -translate-y-1/2 mr-2",
    right: "left-full top-1/2 transform -translate-y-1/2 ml-2",
  };

  const arrowClasses = {
    top: "after:-bottom-2 after:left-1/2 after:-translate-x-1/2 after:border-4 after:border-transparent after:border-t-gray-900",
    bottom: "after:-top-2 after:left-1/2 after:-translate-x-1/2 after:border-4 after:border-transparent after:border-b-gray-900",
    left: "after:-right-2 after:top-1/2 after:-translate-y-1/2 after:border-4 after:border-transparent after:border-l-gray-900",
    right: "after:-left-2 after:top-1/2 after:-translate-y-1/2 after:border-4 after:border-transparent after:border-r-gray-900",
  };

  return (
    <div className="relative group">
      {children}
      <div
        id={id}
        className={`absolute opacity-0 group-hover:opacity-100 transition bg-gray-900 text-white text-xs px-2 py-1 rounded shadow-xl whitespace-nowrap z-50 text-center ${positionClasses[position]} ${arrowClasses[position]}`}
      >
        {label}
      </div>
    </div>
  );
};
